import React from 'react';
import { motion } from 'framer-motion';

const IconInterfaces = (props) => (
  <motion.svg {...props} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="18" y="18" width="64" height="64" rx="4" stroke="currentColor" strokeWidth="4"/>
    <path d="M18 35H82" stroke="currentColor" strokeWidth="4"/>
    <path d="M30 26H38" stroke="currentColor" strokeWidth="4" strokeLinecap="round"/>
    <path d="M42 26H46" stroke="currentColor" strokeWidth="4" strokeLinecap="round"/>
  </motion.svg>
);

export default IconInterfaces;